<!-- eslint-disable -->
<template lang="pug">
    cs-modal(@close="$emit('close')")
        .item-state__header(slot='header')
            .item-state__icon
                svg-icon(size="xxx-large", name="circle-check")
            | {{ stateText }}
</template>

<script>
    /*eslint-disable*/
    import CsModal from "../elements/CsModal.vue";

    export default {
        props: {
            isUpdated: {
                type: Boolean,
                default: false,
            },
            isCreated: {
                type: Boolean,
                default: false,
            },
            isDeleted: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            stateText () {
                if (this.isUpdated) {
                    return this.$i18n.t('list.list_itemSuccessfullyUpdated');
                }
                if (this.isCreated) {
                    return this.$i18n.t('list.list_itemSuccessfullyCreated');
                }
                if (this.isDeleted) {
                    return this.$i18n.t('list.list_list_deletedSuccessfully');
                }
            }
        },
        components: {
            CsModal,
        }
    }
</script>

<style scoped lang="scss">
    .item-state__icon {
        color: $hsl-color-green-48;
        margin-bottom: 20px;
    }
</style>
